/**
 * This file will contain utility functions related to Handsontable instance data manipulation.
 */
import Handsontable from 'handsontable';

// Utils
import { getTableCellData } from '../rawUtils/tableCellDataUtils';

// Types
import { CellData } from '../../../../../common/table/TableTypes';

/**
 * Returns all the cell data via the HoT instance.
 */
export const getHotTableData = (hotInstance: Handsontable | null | undefined): CellData[][] | undefined => {
    if (!hotInstance) return;

    const cellMetas = hotInstance.getCellsMeta();
    const rowCount = hotInstance.countRows();
    const colCount = hotInstance.countCols();

    return getTableCellData(cellMetas, rowCount, colCount);
};
